const useVideoStartTime = ({videoRef, startTime, onLoadedMetadata}) => {
    const handleLoadedMetadataWithStart = (event) => {
        if (typeof startTime === 'number' && videoRef.current) {
            videoRef.current.currentTime = startTime;
        }

        onLoadedMetadata?.(event);
    };

    return {handleLoadedMetadataWithStart};
};

export default useVideoStartTime;
